// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__R2Bap","Menu":"SiderContentC_Menu__meSBZ"};